import { PacketAction, PacketFamily } from 'eolib';
import type { Client } from '@/client';
import { EffectAnimation, EffectTargetTile, EffectTargetCharacter, EffectTargetNpc } from '@/render';
import type { EffectMetadata } from '@/utils';
import type { Vector2 } from '@/vector';

class RangedProjectile extends EffectAnimation {
  constructor(id:number,private from:Vector2,private to:Vector2,metadata:EffectMetadata){
    super(id,new EffectTargetTile({...from}),metadata);
    this.loops=1;
  }
  override tick(){
    super.tick();
    const progress=Math.min(1,this.animationFrame/Math.max(1,this.metadata.frames-1));
    (this.target as EffectTargetTile).coords={x:this.from.x+(this.to.x-this.from.x)*progress,y:this.from.y+(this.to.y-this.from.y)*progress};
  }
}
export function registerNpcRanged(client:Client){
  client.bus.registerPacketHandler(59 as PacketFamily,PacketAction.Reply,reader=>{
    try{
      const p=JSON.parse(reader.getString());
      if(p.map!==client.mapId||!Number.isInteger(p.npc)||!Number.isInteger(p.target)||!Number.isInteger(p.effect)||typeof p.blocked!=='boolean')return;
      const targetKind=p.target_kind??'player';
      if(targetKind!=='player'&&targetKind!=='npc')return;
      if(p.npc<0||p.npc>249||p.effect<1||p.effect>255||p.target<(targetKind==='npc'?0:1)||p.target>(targetKind==='npc'?249:64008))return;
      for(const pos of [p.from,p.to])if(!pos||!Number.isInteger(pos.x)||!Number.isInteger(pos.y)||pos.x<0||pos.y<0||pos.x>client.map.width||pos.y>client.map.height)return;
      const npc=client.getNpcByIndex(p.npc);if(!npc)return;
      // The old dragon profile used a falling fireball: moving that sprite between
      // tiles cannot orient its baked-in vertical trail. Use the existing radial
      // Fire Blast impact, including when an older server still sends effect 14.
      const effectId=npc.id===225 && p.effect===14 ? 28 : p.effect;
      const meta=client.getEffectMetadata(effectId);if(!meta)return;
      if(effectId===28 || effectId===29){
        // Fire bursts and growing vines belong at the victim, not on a projectile.
        const target=targetKind==='npc'&&client.getNpcByIndex(p.target)
          ? new EffectTargetNpc(p.target)
          : targetKind==='player'&&client.getCharacterById(p.target)
          ? new EffectTargetCharacter(p.target)
          : new EffectTargetTile({...p.to});
        client.animationController.effects.push(new EffectAnimation(effectId,target,meta));
        if(meta.sfx)client.audioController.playAtPosition(meta.sfx,p.to);
      }else{
        client.animationController.effects.push(new RangedProjectile(effectId,p.from,p.to,meta));
      }
      if(p.blocked&&targetKind==='player')client.spellController.playSpellEffect(47,new EffectTargetCharacter(p.target));
    }catch{/* Optional effect packets cannot interrupt map loading. */}
  });
}
